import { UserAllocatedUserOutput } from './user-allocated-user-output.model';


export class UserLicenseDetailsWithStatusOutput implements IUserLicenseDetailsWithStatusOutput {
    /** The auto-generated id of the user license details master */
    user_license_id!: number;
    /** The company name with 255 character */
    company_name!: string;
    /** The user name with 255 character */
    user_name!: string;
    /** The telephone number */
    telephone_number!: string;
    /** The license activation date with 10 character limit */
    license_activation_date!: string;
    /** The license expiry date with 10 character limit */
    license_expiry_date!: string;
    /** The license extended date with 10 character limit */
    license_extend_date!: string;
    /** The remark with 500 character limit */
    remark!: string;
    /** Branch name of user */
    branch_name!: string;
    allocated_vehicles!: UserAllocatedUserOutput[];
    /** Manage user license details. 0 For De-active, 1 For Active */
    status!: number;

    constructor(data?: IUserLicenseDetailsWithStatusOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.user_license_id = _data["user_license_id"];
            this.company_name = _data["company_name"];
            this.user_name = _data["user_name"];
            this.telephone_number = _data["telephone_number"];
            this.license_activation_date = _data["license_activation_date"];
            this.license_expiry_date = _data["license_expiry_date"];
            this.license_extend_date = _data["license_extend_date"];
            this.remark = _data["remark"];
            this.branch_name = _data["branch_name"];
            if (Array.isArray(_data["allocated_vehicles"])) {
                this.allocated_vehicles = [] as any;
                for (let item of _data["allocated_vehicles"])
                    this.allocated_vehicles!.push(UserAllocatedUserOutput.fromJS(item));
            }
            this.status = _data["status"];
        }
    }

    static fromJS(data: any): UserLicenseDetailsWithStatusOutput {
        data = typeof data === 'object' ? data : {};
        let result = new UserLicenseDetailsWithStatusOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["user_license_id"] = this.user_license_id;
        data["company_name"] = this.company_name;
        data["user_name"] = this.user_name;
        data["telephone_number"] = this.telephone_number;
        data["license_activation_date"] = this.license_activation_date;
        data["license_expiry_date"] = this.license_expiry_date;
        data["license_extend_date"] = this.license_extend_date;
        data["remark"] = this.remark;
        data["branch_name"] = this.branch_name;
        if (Array.isArray(this.allocated_vehicles)) {
            data["allocated_vehicles"] = [];
            for (let item of this.allocated_vehicles)
                data["allocated_vehicles"].push(item.toJSON());
        }
        data["status"] = this.status;
        return data; 
    }
}

export interface IUserLicenseDetailsWithStatusOutput {
    /** The auto-generated id of the user license details master */
    user_license_id: number;
    /** The company name with 255 character */
    company_name: string;
    /** The user name with 255 character */
    user_name: string;
    /** The telephone number */
    telephone_number: string;
    /** The license activation date with 10 character limit */
    license_activation_date: string;
    /** The license expiry date with 10 character limit */
    license_expiry_date: string;
    /** The license extended date with 10 character limit */
    license_extend_date: string;
    /** The remark with 500 character limit */
    remark: string;
    /** Branch name of user */
    branch_name: string;
    allocated_vehicles: UserAllocatedUserOutput[];
    /** Manage user license details. 0 For De-active, 1 For Active */
    status: number;
}

